import type { SpecialType } from '@iheartjane/types';

export const doesSpecialApply = (
  applicableSpecialIds: number[] | null,
  specialId: number | null,
  specialType: SpecialType
): boolean => {
  if (!specialId || !applicableSpecialIds) return false;

  if (specialType !== 'product' && specialType !== 'bundle') return false;

  return applicableSpecialIds.includes(specialId);
};
